<div class="deck-card">
  <content-loader height="200" width="300" primaryColor="#eee" secondaryColor="#ddd">
    <svg:rect x="0" y="0" width="300" height="200" />
  </content-loader>
</div>
